import { render } from "./recordEdit.vue?vue&type=template&id=c30d5c0e&scoped=true"
import script from "./recordEdit.vue?vue&type=script&lang=js"
export * from "./recordEdit.vue?vue&type=script&lang=js"

import "./recordEdit.vue?vue&type=style&index=0&id=c30d5c0e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30d5c0e"],['__file',"src/views/widget/questionRegForm/recordEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c30d5c0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c30d5c0e', __exports__)) {
    console.log('reload')
    api.reload('c30d5c0e', __exports__)
  }
  
  module.hot.accept("./recordEdit.vue?vue&type=template&id=c30d5c0e&scoped=true", () => {
    console.log('re-render')
    api.rerender('c30d5c0e', render)
  })

}


export default __exports__